import { Box, styled } from '@mui/material';

export const StyledSidebarTitle = styled(Box, { shouldForwardProp: (prop) => prop !== 'folded' })<{
  folded: boolean;
}>(({ theme, folded }) => ({
  color: theme.palette.lwSecondary[60],
  fontSize: '13px',
  fontVariationSettings: '"wght" 700',
  fontWeight: 700,
  paddingLeft: theme.spacing(2),
  textTransform: 'uppercase',
  ...(folded && {
    fontSize: '10px',
    paddingLeft: 0,
    textAlign: 'center',
  }),
}));
